<template>
	<span class="atCenter">
		<span
			v-for="(item, index) in max"
			:key="index"
			class="mr3x icon-box"
			@mouseover.stop="moveStar(index)"
			@mouseleave.stop="resetStart"
			@click.stop="setStar(index)"
			:class="addClass"
		>
			<Icon
				:name="position > index ? fullName : voidName"
				class="icon-i"
				:class="{ [fullColor]: position > index, [voidColor]: position <= index, rateIcon: !disabled, [iconSize]: true }"
				:ref="'icon' + index"
			/>
		</span>
	</span>
</template>

<script>
export default {
	name: "Rate",
	model: {
		prop: "level",
		event: "setLevel",
	},
	data() {
		return {
			position: -1,
		};
	},
	props: {
		fullName: {
			// 选中时图标
			type: String,
			default: "star-on",
		},
		voidName: {
			// 未选中图标
			type: String,
			default: "star-off",
		},
		fullColor: {
			// 选中时颜色
			type: String,
			default: "fDanger",
		},
		voidColor: {
			// 未选中颜色
			type: String,
			default: "fSub",
		},
		max: {
			// icon个数
			type: Number,
			default: 5,
		},
		level: {
			// 初始分数
			type: Number,
			required: true,
		},
		disabled: {
			// 是否只读
			type: Boolean,
			default: false,
		},
		iconSize: {
			// 图标大小
			type: String,
			default: "w205x h205x",
		},
		addClass: {
			type: [String, Array],
			default: "",
		},
	},
	methods: {
		moveStar(i) {
			if (this.disabled) return;
			this.position = i + 1;
		},
		resetStart() {
			if (this.disabled) return;
			this.position = this.level;
		},
		setStar(i) {
			if (this.disabled) return;
			this.$emit("setLevel", i + 1);
			this.position = i + 1;
		},
		iconName(i) {
			if (this.position > i) return this.fullName;
			return this.voidName;
		},
	},
	created() {
		this.position = this.level;
	},
	watch: {
		level(newVal) {
			if (newVal < 0) {
				newVal = 0;
			} else if (newVal > this.max) {
				newVal = this.max;
			}
			this.position = newVal;
		},
	},
};
</script>

<style lang="scss" scoped>
.starContainer {
	display: inline-block;
}
.rateIcon {
	-webkit-transition: all 0.3s;
	transition: all 0.3s;
}
.icon-box {
	position: relative;
	z-index: 3;
	display: inline-block;
	&:hover .rateIcon {
		transform: scale(1.1);
	}
	.icon-i {
		position: relative;
		z-index: 1;
	}
	&::after {
		position: absolute;
		top: 0;
		left: 0;
		z-index: 2;
		width: 100%;
		height: 100%;
		content: "";
	}
}
</style>



// WEBPACK FOOTER //
// src/components/common/ui/Rate.vue